import { useUserStore } from '@oai-frontend-monorepo/state-management';
import { parseToken } from '@oai-frontend-monorepo/utils';

export const useIsSubscriber = () => {
  const token = useUserStore((state) => state.token);
  const parsed = parseToken(token);

  const isSubscriber =
    parsed?.groups?.includes('Subscribers') ||
    !parsed?.groups?.includes('Traders');

  return isSubscriber;
};
